const PAYMENTCART_ACTIONS = {
  PAYMENT_CART: {
    PENDING: 'PAYMENT_CART_PENDING',
    SUCCESS: 'PAYMENT_CART_SUCCESS',
    FAILURE: 'PAYMENT_CART_FAILURE',
    UPDATE: 'PAYMENT_CART_UPDATE',
  },
}

export const PAYMENT_CART_STATE = {
  REFRESHED: 'PAYMENT_CART_REFRESHED',
  IN_PROGRESS: 'PAYMENT_CART_PROGRESS',
  SUCCESS: 'PAYMENT_CART_RETRIEVED',
  ERROR: 'PAYMENT_CART_ERROR',
  PENDING: 'PAYMENT_CART_PENDING',
}

export default PAYMENTCART_ACTIONS
